import { PriceFilter } from '../../../components/price-filter-panel/price-filter-panel';

export const pricePanelTitle = 'Price Range';

export const priceFilterList: PriceFilter[] = [
  { id: 1, label: 'Under $5', maxValue: 4.99, selected: false },
  { id: 2, label: '$5 - $9.99', minValue: 5, maxValue: 9.99, selected: false },
  { id: 3, label: '$10 - $14.99', minValue: 10, maxValue: 14.99, selected: false },
  { id: 4, label: '$15 - $19.99', minValue: 15, maxValue: 19.99, selected: false },
  { id: 5, label: '$20 - $24.99', minValue: 20, maxValue: 24.99, selected: false },
  { id: 6, label: '$25 - $29.99', minValue: 25, maxValue: 29.99, selected: false },
  { id: 7, label: '$30 - $49.99', minValue: 30, maxValue: 49.99, selected: false },
  { id: 8, label: '$50 - $99.99', minValue: 50, maxValue: 99.99, selected: false },
  { id: 9, label: '$100 - $249.99', minValue: 100, maxValue: 249.99, selected: false },
  { id: 10, label: '$250 & Above', minValue: 250, selected: false },
];
